import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import { PhaseType } from '@schema/phase'
import {
  creationGuideDisplay,
  InitiativeCreationStep,
} from '../../shared/workflow'
import { ReactNode } from 'react'
import { Title } from '@app/components/core/typography/Title'
import { useTranslations } from '@i18n/useLanguage'
import { Text } from '@app/components/core/typography/Text'

export const CreationGuide = ({
  selectedPhaseType,
  currentStep,
  children,
}: {
  selectedPhaseType: PhaseType | null
  currentStep: InitiativeCreationStep
  children: ReactNode
}) => {
  const steps = creationGuideDisplay(selectedPhaseType, currentStep)
  return (
    <Column
      alignItems="center"
      style={{
        justifyContent: 'center',
        paddingInline: '5rem',
        '@media (max-width: 1400px)': {
          paddingInline: 0,
        },
      }}
    >
      <Row
        gap="5rem"
        alignItems="center"
        style={{
          justifyContent: 'space-between',
        }}
      >
        <CreationGuideAssignment steps={steps} activeStep={currentStep} />
        <Column
          alignItems="stretch"
          style={{ flex: '1 0 30rem', maxWidth: '30rem', alignSelf: 'stretch' }}
        >
          {children}
        </Column>
      </Row>
    </Column>
  )
}

const CreationGuideAssignment = ({
  steps,
  activeStep,
}: {
  steps: InitiativeCreationStep[]
  activeStep: InitiativeCreationStep
}) => {
  const translations = useTranslations().app.dashboard.initiative.creation
  const hasStepNumbers = steps.length > 1
  const active = steps.length === 1 ? steps[0] : activeStep
  return (
    <Column
      gap="2rem"
      style={{
        flex: '1 0 30rem',
        maxWidth: '30rem',
        alignSelf: 'stretch',
        justifyContent: 'center',
      }}
    >
      {steps.map((step, index) => (
        <span key={index}>
          <Title.Hx
            title={step === active ? 'H2' : 'H4'}
            style={{
              color:
                step === active ? 'var(--brand-secondary)' : 'var(--gray-300)',
            }}
          >
            {(hasStepNumbers ? `${index + 1}. ` : '') +
              translations.creationStepTitles[step]}
          </Title.Hx>
          {translations.creationStepDescriptions[step] && (
            <Text.Medium>
              {translations.creationStepDescriptions[step]}
            </Text.Medium>
          )}
        </span>
      ))}
    </Column>
  )
}
